import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpService } from '@app/core/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private dataSubject = new BehaviorSubject<any>(null);
  private fieldsSubject = new BehaviorSubject<any>(null);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public historyData$ = this.dataSubject.asObservable();
  public fieldsData$ = this.fieldsSubject.asObservable();
  public loading$ = this.loadingSubject.asObservable();

  constructor(private httpService: HttpService) {}

  getId(id: number, model: string): Observable<any> {
    if (!id || !model) {
      this.setData([]);
      return of({ data: [] });
    }
    this.loadingSubject.next(true);
    return this.httpService.getHistory(id, model);
  }
  setData(historyData: any): void {
    if (!historyData || !Array.isArray(historyData)) {
      this.dataSubject.next([]);
    } else {
      this.dataSubject.next(this.processHistoryData(historyData));
    }
    this.loadingSubject.next(false);
  }


  setFields(fieldsData: any): void {
    this.fieldsSubject.next(fieldsData);
  }

  private processHistoryData(data: any[]): any[] {
    return data
      .filter((item) => item.$eventType === 'notification')
      .map((item) => {
        try {
          const parsedBody = JSON.parse(item.body);
          return {
            ...item,
            title: parsedBody.title,
            tracks: parsedBody.tracks,
            tags: parsedBody.tags
          };
        } catch (e) {
          console.error('Error parsing history item body:', e);
          return item;
        }
      });
  }
}
